var app = angular.module('leonardo');

var FieldSubgroupService = function(BaseRestService) {
  var service = new BaseRestService('field-subgroups');

  // Constants
  service.STATUS_ACTIVE = '0';
  service.STATUS_DEACTIVATED = '1';

  service.FIELD_TYPES = ['text','bool','integer', 'zone'];
  service.CONDITIONS_TYPES = [{id: 0, label:'OR'}, {id: 1, label:'AND'}];
  service.WIDGET_TYPES = ['normal', 'hidden'];

  service.changeSector = function(subgroup, sectors) {
    return subgroup.patch({sectors: sectors});
  };

  return service;
};

app.factory('FieldSubgroupService', ['BaseRestService', FieldSubgroupService]);
